module.exports = __webpack_public_path__ + "static/media/preview.075fe968.png";